import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';
import { AttachmentFullViewState } from 'owa-attachment-full-data';
import { PreviewContext } from 'owa-attachment-select-actions';
import { isFeatureEnabled } from 'owa-feature-flags';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import ItemId from 'owa-service/lib/contract/ItemId';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { EditInBrowserButtonLabel } from '../../strings.locstring.json';
import loc, { isStringNullOrWhiteSpace } from 'owa-localize';

import openInNewTabContextMenuItemBuilder from './openInNewTabContextMenuItemBuilder';
import { doSaveToCloud } from './saveToCloudContextMenuItemBuilder';
import {
    shouldShowWovenContextMenuItem,
    getOfficeAppIconProps,
    getOfficeAppFromAttachment,
    editIn,
} from './wovenContextMenuItemHelpers';

export default function openInBrowserContextMenuItemBuilder(
    attachment: AttachmentFullViewState,
    providerType?: string,
    targetWindow?: Window,
    sxsId?: string,
    isConsumer?: boolean,
    attachmentOriginalUrl?: string,
    permissionLevel?: AttachmentPermissionLevel,
    previewContext?: PreviewContext,
    parentItemId?: ItemId,
    replaceAttachmentHandler?: (
        attachmentViewState: AttachmentFullViewState,
        attachmentType: AttachmentType,
        isReadOnly: boolean,
        uploadCompleted: boolean
    ) => void,
    AttachLongPathName?: string,
    container?: HTMLElement,
    moveAttachmentToInlineHandler?: (
        attachment: AttachmentFullViewState,
        contentId: string
    ) => Promise<void>,
    referenceAttachmentsSupported?: () => boolean
): IContextualMenuItem {
    const attachmentModel = getAttachment(attachment.attachmentId);
    const officeOnlineApp = getOfficeAppFromAttachment(attachmentModel);

    if (!shouldShowWovenContextMenuItem(attachment, isConsumer)) {
        return openInNewTabContextMenuItemBuilder(attachment, providerType, targetWindow);
    }

    const officeAppIcon = getOfficeAppIconProps(officeOnlineApp);

    return {
        key: 'editInBrowser',
        text: loc(EditInBrowserButtonLabel),
        title: loc(EditInBrowserButtonLabel),
        iconProps:
            isFeatureEnabled('wvn-chicletEditOptions') ||
            isFeatureEnabled('wvn-chicletEditOptionsNoDownload')
                ? { imageProps: officeAppIcon }
                : undefined,
        onClick: () => {
            editIn(
                true /* browser */,
                targetWindow /* currentWindow */,
                attachmentModel /* attachmentModel */,
                officeOnlineApp /* officeOnlineApp */,
                isConsumer /* isConsumer */,
                attachment.isCloudy /* isCloudy */,
                'woven-attachmentContextMenu' /* parentComponentName */,
                !attachment.strategy.isSaveToCloudSupported /* isSaveToCloudDisabled */,
                isStringNullOrWhiteSpace(
                    attachmentModel.model.AttachmentOriginalUrl
                ) /* isSaveToCloudSupported */,
                async () => {
                    /* saveToCloud */
                    await doSaveToCloud(attachment, null, parentItemId);
                }
            );
            logUsage('WovenEditInBrowser', { entryPoint: 'ContextMenu' }, { isCore: true });
        },
    };
}
